import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Button } from '../../../../common/html/button'
import { Element } from '../../../../common/html/element'
import { postMoveOrCopyCompany } from '../../store/thunk'
import { PopupCancel } from './popup/PopupCancel'
import { PopupSaveList } from './popup/popupSaveList/PopupSaveList'
import { RecommendationList } from './popupRecommendationList'
import {
  changePrevSelectedCompanyList,
  selectSelectedCompanyList,
  selectSelectedPortfolioList,
} from './popupRecommendationList/store/slice'
import { SearchInput } from './SearchInput'
import { selectIsShowPopupCancel } from './store/slice'

const HeaderSearch = () => {
  const dispatch = useDispatch()

  const [isShowRecommendationList, setIsShowRecommendationList] =
    useState(false)
  const [isShowSavePopup, setIsShowSavePopup] = useState(false)

  const isShowPopupCancel = useSelector(selectIsShowPopupCancel)
  const selectedCompanyList = useSelector(selectSelectedCompanyList)
  const selectedPortfolioList = useSelector(selectSelectedPortfolioList)

  const onClickSaveList = () => {
    setIsShowSavePopup(true)
  }

  const onClickRecommendationList = () => {
    setIsShowRecommendationList(true)
    dispatch(changePrevSelectedCompanyList(selectedCompanyList))
  }

  const handleApply = () => {
    if (selectedPortfolioList.length) {
      const params = {
        organizationIds: selectedCompanyList.map((item) => item.id),
        targetPorfolioIds: selectedPortfolioList,
        addType: 'IN',
        isMove: false,
      }
      dispatch(postMoveOrCopyCompany(params))
      setIsShowSavePopup(false)
    }
  }

  return (
    <>
      <div
        className="dFlex justifyContentBetween"
        style={{ padding: '12px 6px 6px' }}
      >
        <div className="dFlex alignItemsCenter">
          <SearchInput />
          <div onClick={onClickRecommendationList}>
            <Element
              elementName="span"
              className="cursorPointer"
              style={{ color: '#2C73E8', marginLeft: 8 }}
            >
              <Translate value="companyAnalysis.peerAnalysis.RECOMMENDATION_LIST" />
            </Element>
          </div>
        </div>

        <Button
          label="companyAnalysis.peerAnalysis.SAVE_LIST"
          className="cursorPointer dFlex alignItemsCenter"
          action={onClickSaveList}
          isI18n
          style={{
            padding: '0px 18px',
            border: 'none',
            borderRadius: 4,
            color: '#FFFFFF',
            backgroundColor: '#2C73E8',
          }}
        />
      </div>

      <RecommendationList
        isShow={isShowRecommendationList}
        setShow={() => setIsShowRecommendationList(false)}
      />
      <PopupCancel
        isShow={isShowPopupCancel}
        setIsShowRecommendationList={setIsShowRecommendationList}
      />
      <PopupSaveList
        isShow={isShowSavePopup}
        handleClose={() => setIsShowSavePopup(false)}
        handleApply={handleApply}
      />
    </>
  )
}

export default HeaderSearch
